import '../style/global.css';

import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';
import { Button, FormControlLabel, IconButton, Paper, Popover, Stack, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography } from '@mui/material';
import Box from "@mui/material/Box";
import { DataGrid } from '@mui/x-data-grid';
import { GridColDef } from '@mui/x-data-grid/models/colDef';
import React from "react";
import { useHistory, useLocation } from 'react-router-dom';
import { ActivityEnum, AdminSubactivityEnum, useUserActivityTracker } from '../UserActivityTracker';
import { AudioApi } from '../api/AudioApi';
import { Sentence, SentenceApi, SentenceChinese, SentenceFactory } from '../api/SentenceApi';
import { SpeakerRole, SpeakerRoles } from '../api/SpeakerApi';
import { IUser, UserApi } from '../api/UserApi';
import background from '../asset/background-login.png';
import female_avatar_1 from '../asset/female_avatar_1.png';
import female_avatar_2 from '../asset/female_avatar_2.png';
import male_avatar from '../asset/male_avatar.png';
import { handleErrorMessage } from '../component/ErrorDialog';
import AppBarContext from '../context/AppBarContext';
import { useAudioPlayer } from '../context/AudioPlayerContext';

// npm install @mui/x-data-grid --legacy-peer-deps
// npm install @mui/x-data-grid@5.13.1

export default function RegenerateAudio() {

    useUserActivityTracker(ActivityEnum.Admin, AdminSubactivityEnum.RegenerateAudio)

    const { setErrorMessage } = React.useContext(AppBarContext)
    const history = useHistory();
    const location = useLocation();

    const { playAudio } = useAudioPlayer();

    const [sentenceList, setSentenceList] = React.useState<Sentence[]>([]);
    const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 10 });

    const [selectedIndex, setSelectedIndex] = React.useState<number | null>(null);

    const [textQuery, setTextQuery] = React.useState('');
    const [regenButtonEnabled, setRegenButtonEnabled] = React.useState(true)


    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [selectedSentence, setSelectedSentence] = React.useState<Sentence | null>(null);

    const [sentenceProcessingQueue, setSentenceProcessingQueue] = React.useState<Sentence[]>([]);

    const tableBottomRef = React.useRef<HTMLDivElement>(null);
    const [shouldScroll, setShouldScroll] = React.useState(false);

    const [isAudioSpeedFast, setIsAudioSpeedFast] = React.useState(true);
    const [isSettingsSaving, setIsSettingsSaving] = React.useState(false);

    const refreshSentenceProcessingQueue = React.useCallback(() => {
        SentenceApi.getSentenceProcessingQueue()
            .then(response => {
                // check if the response was successful
                if (response.status >= 300) {
                    throw new Error('Getting male audio was not ok statuscode=' + response.status + " " + response.statusText);
                }
                return response.data;
            })
            .then(list => {
                setSentenceProcessingQueue(list.map(SentenceFactory))
            })
            .catch(err => {
                handleErrorMessage(err, setErrorMessage, history, location);
            })
    }, [setSentenceProcessingQueue, setErrorMessage, history, location])

    React.useEffect(() => {
        refreshSentenceProcessingQueue()
    }, [refreshSentenceProcessingQueue])

    const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>, row: any, index: number) => {
        setAnchorEl(event.currentTarget);
        setSelectedSentence(row);
        setSelectedIndex(index);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
        setSelectedSentence(null);
    };


    const columns: GridColDef[] = [
        { field: 'id', headerName: 'ID', width: 90 },
        { field: 'text', headerName: 'Text', width: 300 },
        { field: 'pinyin', headerName: 'Pinyin', width: 150 },
    ];

    const handleAudioSpeedToggle = () => {
        setIsSettingsSaving(true)
        const newValue = !isAudioSpeedFast;
        setIsAudioSpeedFast(newValue);

        const updatedUser: IUser = {
            audio_speed_fast: newValue,
        };
        UserApi.update(updatedUser)
            .then(response => {
                if (response.status >= 300) {
                    throw new Error('Saving audio speed was not ok statuscode=' + response.status + ' ' + response.statusText);
                }
                return response.data;
            })
            .catch(err => {
                handleErrorMessage(err, setErrorMessage, history, location);
            })
            .finally(() => {
                setIsSettingsSaving(false);
            });
    }

    const handleMale = () => {
        if (selectedSentence) {
            AudioApi.getMale(selectedSentence.id)
                .then(response => {
                    // check if the response was successful
                    if (response.status >= 300) {
                        throw new Error('Getting male audio was not ok statuscode=' + response.status + " " + response.statusText);
                    }
                    return response.data;
                })
                .then(blob => {
                    playAudio(blob)
                })
                .catch(err => {
                    handleErrorMessage(err, setErrorMessage, history, location);
                })
        }
    }

    const handleFemale = () => {
        if (selectedSentence) {
            AudioApi.getFemale(selectedSentence.id)
                .then(response => {
                    // check if the response was successful
                    if (response.status >= 300) {
                        throw new Error('Getting male audio was not ok statuscode=' + response.status + " " + response.statusText);
                    }
                    return response.data;
                })
                .then(blob => {
                    playAudio(blob)
                })
                .catch(err => {
                    handleErrorMessage(err, setErrorMessage, history, location);
                })
        }
    }
    const handleFemale2 = () => {
        if (selectedSentence) {
            AudioApi.getFemale2(selectedSentence.id)
                .then(response => {
                    // check if the response was successful
                    if (response.status >= 300) {
                        throw new Error('Getting male audio was not ok statuscode=' + response.status + " " + response.statusText);
                    }
                    return response.data;
                })
                .then(blob => {
                    playAudio(blob)
                })
                .catch(err => {
                    handleErrorMessage(err, setErrorMessage, history, location);
                })
        }
    }
    const handleSpeakerA = () => {
        if (selectedSentence) {
            AudioApi.getSpeakerA(selectedSentence.id)
                .then(response => {
                    // check if the response was successful
                    if (response.status >= 300) {
                        throw new Error('Getting male audio was not ok statuscode=' + response.status + " " + response.statusText);
                    }
                    return response.data;
                })
                .then(blob => {
                    playAudio(blob)
                })
                .catch(err => {
                    handleErrorMessage(err, setErrorMessage, history, location);
                })
        }
    }
    const handleSpeakerB = () => {
        if (selectedSentence) {
            AudioApi.getSpeakerB(selectedSentence.id)
                .then(response => {
                    // check if the response was successful
                    if (response.status >= 300) {
                        throw new Error('Getting male audio was not ok statuscode=' + response.status + " " + response.statusText);
                    }
                    return response.data;
                })
                .then(blob => {
                    playAudio(blob)
                })
                .catch(err => {
                    handleErrorMessage(err, setErrorMessage, history, location);
                })
        }
    }
    React.useEffect(() => {
        if (textQuery.trim().length > 0) {
            SentenceApi.searchSentenceByText(textQuery.trim())
                .then(response => {
                    if (response.status < 300) {
                        return response.data;
                    }
                    throw new Error("Unable to SentenceApi.searchSentenceByText() " + response.status)
                })
                .then(list => {
                    const castedList = list.map(SentenceFactory);
                    setSentenceList(castedList);
                })
                .catch(err => {
                    handleErrorMessage(err, setErrorMessage, history, location);
                })
        }
    }, [textQuery, history, location, setErrorMessage]);

    const handleRegenerateClick = (speakerRoles?: SpeakerRole[]) => {
        if (selectedSentence) {
            setRegenButtonEnabled(false)
            SentenceApi.regenerateSentenceAudio(selectedSentence.id, speakerRoles)
                .then(response => {
                    if (response.status < 300) {
                        return response.data;
                    }
                    throw new Error("Unable to SentenceApi.regenerate_sentence_audio() " + response.status)
                })
                .then(_data => {
                    refreshSentenceProcessingQueue()
                    setShouldScroll(true);
                    handlePopoverClose();
                    setRegenButtonEnabled(true);
                })
                .catch(err => {
                    handleErrorMessage(err, setErrorMessage, history, location);
                })
        }
    }
    React.useEffect(() => {
        if (shouldScroll && tableBottomRef.current) {
            // console.log('Waiting extra frames before scrolling...');
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        // console.log('Scrolling page to bottom...');
                        tableBottomRef.current!.scrollIntoView({ behavior: 'smooth' });
                        setShouldScroll(false);
                    });
                });
            });
        }
    }, [sentenceProcessingQueue, shouldScroll]);

    React.useEffect(() => {
        setRegenButtonEnabled(true)
    }, [selectedIndex])

    const popoverOpen = Boolean(anchorEl);

    React.useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (!popoverOpen || selectedIndex == null) return;

            const { page: currentPage, pageSize } = paginationModel;
            const totalPages = Math.ceil(sentenceList.length / pageSize);
            let newPage = currentPage;
            let newIndex = selectedIndex;

            if (event.key === 'ArrowUp') {
                newIndex = Math.max(0, selectedIndex - 1);
            } else if (event.key === 'ArrowDown') {
                newIndex = Math.min(sentenceList.length - 1, selectedIndex + 1);
            } else if (event.key === 'ArrowLeft') {
                if (currentPage > 0) {
                    newPage = currentPage - 1;
                    const startIndex = newPage * pageSize;
                    const endIndex = Math.min(startIndex + pageSize, sentenceList.length);
                    newIndex = endIndex - 1; // last row of previous page
                } else {
                    return;
                }
            } else if (event.key === 'ArrowRight') {
                if (currentPage < totalPages - 1) {
                    newPage = currentPage + 1;
                    newIndex = newPage * pageSize; // first row of next page
                } else {
                    return;
                }
            } else {
                return;
            }

            const newRow = sentenceList[newIndex];
            setSelectedIndex(newIndex);
            setPaginationModel((prev) => ({ ...prev, page: newPage }));

            setTimeout(() => {
                const updatedRowEl = document.querySelector(`[data-id="${newRow.id}"]`);
                if (updatedRowEl) {
                    setSelectedSentence(newRow);
                    setAnchorEl(updatedRowEl as HTMLElement);
                    updatedRowEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }, 50);

            event.preventDefault();
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [popoverOpen, selectedIndex, sentenceList, paginationModel]);

    return (
        <div style={{
            display: 'flex', // Use flex to allow easy centering
            flexDirection: 'column', // Changed to stack children vertically
            justifyContent: 'center', // Center horizontally
            alignItems: 'center', // Center vertically
            // minHeight: 'calc(100vh - 85px)', // Ensure the div takes at least the full viewport height
            width: '100%', // Ensure the div takes the full viewport width
            padding: 0, // Reset any padding
            backgroundImage: `url(${background})`, // Your background image
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover', // Cover the entire size of the div
            backgroundPosition: 'center', // Center the background image
        }}>
            <Box sx={{ display: 'flex', gap: 2, mb: 2, width: '50%' }}>
                <TextField
                    label="Text Search Query"
                    value={textQuery}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setTextQuery(e.target.value)}
                    fullWidth
                />
            </Box>

            <Box
                sx={{
                    mt: 4,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    // maxHeight: 'calc(100vh - 300px)', // Viewport height minus 100px
                    width: '90%', // Set the width of the Box
                    backgroundColor: '#FFFFFF',
                    borderRadius: '16px',
                    overflowY: 'auto', // Allows content to scroll if it overflows the Y axis
                    border: '1.5px solid rgba(82, 99, 125, 0.2)', // Added border with color and transparency
                    padding: 4,
                    position: 'relative', // Required for absolute children to anchor
                }}
            >
                <DataGrid
                    rows={sentenceList}
                    columns={columns}
                    autoHeight
                    pagination
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                    pageSizeOptions={[10, 25, 50]}
                    disableRowSelectionOnClick
                    onRowClick={(params, event) => {
                        const index = sentenceList.findIndex(row => row.id === params.id);
                        handlePopoverOpen(event, params.row, index)
                    }}

                    getRowClassName={(params) =>
                        selectedSentence != null && selectedSentence.id === params.row.id ? 'Mui-selected-row' : ''
                    }
                    sx={{
                        width: '100%',
                        '& .MuiDataGrid-row': {
                            cursor: 'pointer',
                            transition: 'background-color 0.2s ease',
                        },
                        '& .MuiDataGrid-row:hover': {
                            backgroundColor: '#F0F4FF', // light blue or any hover color
                        },
                        '& .MuiDataGrid-cell': {
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        },
                        '& .Mui-selected-row': {
                            outline: '2px solid #0062FF',
                            backgroundColor: '#F0F4FF',
                        },
                    }}
                />
                <Popover
                    open={popoverOpen}
                    anchorEl={anchorEl}
                    onClose={handlePopoverClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                >
                    <Box sx={{ p: 2, maxWidth: '80vw' }}>
                        {selectedSentence && (
                            <Stack spacing={2}>
                                {/* Speaker Icon and Close Icon in same row */}
                                <Stack direction="row" justifyContent="space-between" alignItems="center">
                                    <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                        <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                                            <span style={{ border: '1px solid #ccc', borderRadius: 4, padding: '2px 6px', fontSize: '0.85rem' }}>↑</span>
                                            <span style={{ border: '1px solid #ccc', borderRadius: 4, padding: '2px 6px', fontSize: '0.85rem' }}>↓</span>
                                        </span>
                                        navigate rows
                                    </Typography>
                                    <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                        <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                                            <span style={{ border: '1px solid #ccc', borderRadius: 4, padding: '2px 6px', fontSize: '0.85rem' }}>←</span>
                                            <span style={{ border: '1px solid #ccc', borderRadius: 4, padding: '2px 6px', fontSize: '0.85rem' }}>→</span>
                                        </span>
                                        change page
                                    </Typography>

                                    <IconButton onClick={handlePopoverClose}>
                                        <CloseRoundedIcon />
                                    </IconButton>
                                </Stack>
                                {/* Display content */}
                                <Stack spacing={1}>
                                    <Typography variant="body1"><strong>Text:</strong> {selectedSentence.text || '—'}</Typography>
                                    {selectedSentence instanceof SentenceChinese && (
                                        <Typography variant="body1"><strong>Pinyin:</strong> {selectedSentence.pinyin || '—'}</Typography>
                                    )}
                                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                                        <Stack direction="row" alignItems="flex-start"> { /* left side audio buttons */}

                                            <FormControlLabel
                                                control={<Switch checked={isAudioSpeedFast} onChange={handleAudioSpeedToggle} size="small" />}
                                                label={
                                                    <Typography variant="caption" color="textSecondary">
                                                        {isAudioSpeedFast ? 'Fast' : 'Slow'}
                                                    </Typography>
                                                }
                                                labelPlacement="end"
                                                sx={{ margin: 0, marginLeft: '1em', alignSelf: 'center' }}
                                            />
                                            {isSettingsSaving == false && (<>
                                                <Stack alignItems="center" sx={{ ml: '1em' }}>
                                                    <img src={male_avatar} alt="Male" onClick={() => handleMale()} style={{ maxHeight: '4em', maxWidth: '4em', cursor: 'pointer' }} />
                                                    <Tooltip title="Regenerate Male">
                                                        <span><IconButton size="small" aria-label="Regenerate Male" disabled={!regenButtonEnabled} onClick={() => handleRegenerateClick([SpeakerRoles.maleTeacher])}><RefreshRoundedIcon fontSize="inherit" /></IconButton></span>
                                                    </Tooltip>
                                                </Stack>
                                                <Stack alignItems="center" sx={{ ml: '1em' }}>
                                                    <img src={female_avatar_1} alt="Female 1" onClick={() => handleFemale()} style={{ maxHeight: '4em', maxWidth: '4em', cursor: 'pointer' }} />
                                                    <Tooltip title="Regenerate Female 1">
                                                        <span><IconButton size="small" aria-label="Regenerate Female 1" disabled={!regenButtonEnabled} onClick={() => handleRegenerateClick([SpeakerRoles.femaleTeacher])}><RefreshRoundedIcon fontSize="inherit" /></IconButton></span>
                                                    </Tooltip>
                                                </Stack>
                                                <Stack alignItems="center" sx={{ ml: '1em' }}>
                                                    <img src={female_avatar_2} alt="Female 2" onClick={() => handleFemale2()} style={{ maxHeight: '4em', maxWidth: '4em', cursor: 'pointer' }} />
                                                    <Tooltip title="Regenerate Female 2">
                                                        <span><IconButton size="small" aria-label="Regenerate Female 2" disabled={!regenButtonEnabled} onClick={() => handleRegenerateClick([SpeakerRoles.femaleTeacher2])}><RefreshRoundedIcon fontSize="inherit" /></IconButton></span>
                                                    </Tooltip>
                                                </Stack>
                                                <Stack alignItems="center" sx={{ ml: '1em' }}>
                                                    <Box onClick={() => handleSpeakerA()} sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                                        <Typography sx={{ fontSize: '24px', width: '48px', height: '48px', borderRadius: '50%', backgroundColor: '#e0e0e0', color: '#000', display: 'flex', alignItems: 'center', justifyContent: 'center', userSelect: 'none' }}>A</Typography>
                                                    </Box>
                                                    <Tooltip title="Regenerate Speaker A">
                                                        <span><IconButton size="small" aria-label="Regenerate Speaker A" disabled={!regenButtonEnabled} onClick={() => handleRegenerateClick([SpeakerRoles.speakerA])}><RefreshRoundedIcon fontSize="inherit" /></IconButton></span>
                                                    </Tooltip>
                                                </Stack>
                                                <Stack alignItems="center" sx={{ ml: '1em' }}>
                                                    <Box onClick={() => handleSpeakerB()} sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                                        <Typography sx={{ fontSize: '24px', width: '48px', height: '48px', borderRadius: '50%', backgroundColor: '#e0e0e0', color: '#000', display: 'flex', alignItems: 'center', justifyContent: 'center', userSelect: 'none' }}>B</Typography>
                                                    </Box>
                                                    <Tooltip title="Regenerate Speaker B">
                                                        <span><IconButton size="small" aria-label="Regenerate Speaker B" disabled={!regenButtonEnabled} onClick={() => handleRegenerateClick([SpeakerRoles.speakerB])}><RefreshRoundedIcon fontSize="inherit" /></IconButton></span>
                                                    </Tooltip>
                                                </Stack>
                                            </>)}

                                        </Stack>
                                        <Stack direction="row" sx={{ ml: 4 }} alignItems="center"> { /* right side regenerate button */}
                                            <Button disabled={!regenButtonEnabled} onClick={() => handleRegenerateClick()}>Regenerate All</Button>
                                        </Stack>
                                    </Stack>
                                </Stack>
                            </Stack>
                        )}
                    </Box>
                </Popover>
            </Box>
            <TableContainer component={Paper} sx={{ maxHeight: 300, width: '90%' }}>
                <Typography variant="h4" align="center" sx={{ mb: 2, mt: 2 }}>
                    Sentence Processing Queue
                </Typography>
                <Table size="small" stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell>ID</TableCell>
                            <TableCell>Text</TableCell>
                            <TableCell>Pinyin</TableCell>
                            <TableCell align="right">
                                <Tooltip title="Refresh">
                                    <IconButton onClick={refreshSentenceProcessingQueue}>
                                        <RefreshRoundedIcon />
                                    </IconButton>
                                </Tooltip>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {sentenceProcessingQueue.map((sentence) => (
                            <TableRow key={sentence.id}>
                                <TableCell>{sentence.id}</TableCell>
                                <TableCell>{sentence.text}</TableCell>
                                <TableCell>
                                    {sentence instanceof SentenceChinese && (<>{sentence.pinyin.join(' ')}</>)}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <div ref={tableBottomRef} style={{ height: '2em' }} />
        </div>
    );
}
